"use client";

import Image from "next/image";

function CrossIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      className="transition-transform duration-200 group-open:rotate-45"
    >
      <line x1="6" y1="1" x2="6" y2="11" />
      <line x1="1" y1="6" x2="11" y2="6" />
    </svg>
  );
}

export default function ProcessSection({ items = [] }) {
  if (!items.length) return null;

  return (
    <section style={{ padding: "0 var(--spacing-pagePadding) 48px" }}>
      <div className="max-w-lg mx-auto">
        <div className="space-y-0">
          {items.map((item, idx) => (
            <details
              key={item.id}
              className="group stagger-fade-in"
              style={{
                borderBottom: "1px solid var(--color-cardBorder)",
                "--stagger-delay": `${idx * 0.08}s`,
              }}
            >
              <summary
                className="flex items-center justify-between py-5 cursor-pointer list-none transition-colors duration-200"
                style={{ color: "var(--color-text)" }}
              >
                <div className="flex items-center gap-4">
                  <span
                    className="text-xs tracking-widest"
                    // a11y fix (axe: color-contrast):
                    // 0.65 opacity gave 4.34:1, use textSecondary which already meets AA
                    style={{ color: "var(--color-textSecondary)" }}
                  >
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <h2
                    className="text-sm font-medium tracking-wide"
                    // a11y fix (axe: heading-order): page has h1 from PageHeader,
                    // section items should be h2 not h3
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    {item.title}
                  </h2>
                </div>
                <span style={{ color: "var(--color-textMuted)" }}>
                  <CrossIcon />
                </span>
              </summary>

              <div
                className="pb-6 pl-10"
                style={{
                  borderLeft: "2px solid var(--color-accent)",
                  borderLeftColor:
                    "color-mix(in srgb, var(--color-accent) 25%, transparent)",
                  marginLeft: "7px",
                }}
              >
                {item.imageUrl && (
                  <div className="pl-5 mb-4" style={{ maxWidth: "400px" }}>
                    <Image
                      src={item.imageUrl}
                      alt={item.altText || item.title}
                      width={400}
                      height={400}
                      sizes="400px"
                      className="w-full h-auto rounded-lg"
                    />
                  </div>
                )}
                {item.body && (
                  <div className="space-y-2 pl-5">
                    {item.body
                      .split("\n")
                      .filter(Boolean)
                      .map((line, i) => (
                        <p
                          key={i}
                          className="text-sm leading-7"
                          style={{ color: "var(--color-textSecondary)" }}
                        >
                          {line}
                        </p>
                      ))}
                  </div>
                )}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
